import React from "react";
import { API_URL } from "../../constants/api";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  apiRequest,
  apiPost,
  apiPut,
  spsApiPost,
  uploadSpsAPiRequest,
  getSpsAPiRequest,
  apiBatchRequest
} from "../../utils/api_service";
import "./requests.less";
import LabelWithSelect from "../common/selectWithLabel/selectWithLabel";
import { ShowToast, toastType } from "../../utils/toast-service";
import { validateInput } from "../../utils/validations";
import { convertIntoDDFormat } from "../../utils/generic";
import uniqBy from "lodash/uniqBy";
import {
  GetUserName,
  IsSectionVisible,
  GetUserConfiguration,
  IsAdmin,
  PaperComponent,
  getToolTipText,
  GetEnableProperty,
  GetPropertyVisibility
} from "../../utils/helper";
import FileAttachments from "../common/sharepoint-upload/file-attachments";
import { getSharepointUrl } from "../common/sharepoint-upload/sharepoint_api";
import { getSPSTokenData, setSPSToken } from "../../constants/constants";
import KeyBoardDateTimePickers from "../common/KeyboardDateTimePicker/DatePicker";
import moment from "moment";
import {
  INCIDENT_STATUS,
  SECTIONS,
  Operators,
  DCOP_SOURCE_SYSTEM,
  SHAREPOINT_SOURCE_SYSTEM,
  TOOLTIP_LABEL
} from "../../constants/appConstants";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import commonLabels from "../../constants/messageConstants";
import MultiSelectDD from "../common/multiSelectDD";
import {
  AppBar,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  InputLabel,
  Link
} from "@material-ui/core";
import { IoMdCloseCircleOutline } from "react-icons/io";
import PrintIcon from "@material-ui/icons/Print";
import { PRINT_HSE_FORM } from "../../constants/ssrs_api";
import { printForm } from "../../utils/downloading";

let uploadFileList = [];

const hseEventNotification = [
  {
    name: "Email Description",
    key: "emailDescription"
  },
  {
    name: "Event Type",
    key: "eventType"
  },
  {
    name: "Impact",
    key: "impact"
  },
  {
    name: "Customer",
    key: "customer"
  },
  {
    name: "Areas Affected",
    key: "areasAffected"
  },
  {
    name: "Actions Taken",
    key: "actionsTaken"
  },
  {
    name: "Outcome",
    key: "outCome"
  },
  {
    name: "Area Manager",
    key: "areaManager"
  },
  {
    name: "Responder",
    key: "responder"
  },
  {
    name: "Systems Affected",
    key: "systemsAffected"
  }
];

class AddUpdateIncident extends React.Component {
  constructor(props) {
    super(props);
    const userName = GetUserName();
    this.state = {
      getToolTip: [],
      loginUserMail: GetUserConfiguration().email,
      incidentCode: "",
      incidentId: props.incidentId ? props.incidentId : 0,
      propertyId: props.propertyId ? props.propertyId : 0,
      observedBy: userName,
      textDescription: "",
      textIncidentNotes: "",
      incidentNotesHistory: "",
      textActionTaken: "",
      observationDate: null,
      incidentStatusId: 0,
      incidentStatus: "",
      createdDate: null,
      contributingFactorMasterDataIds: [],
      subCategoryMasterDataIds: [],
      projectMasterData: props.projectMasterData || [],
      categoryMasterData: props.categoryMasterData || [],
      contributingFactorMasterData: props.contributingFactorMasterData || [],
      subCategoryMasterData: props.subCategoryMasterData || [],
      dataCenterMasterData:  props.incidentId > 0 ? props.dataCenterMasterData || [] : GetEnableProperty((props.dataCenterMasterData || [] || []), SECTIONS.HSE_INCIDENT_CREATE, "DataCenterId" ) ,
      categoryType: "",
      project: "",
      dataCenter: "",
      isIncidentAlreadyCreated: false,
      hasAttachment: false,
      openDialog: false,
      sourceSystem: "DCOP",
      isDcopUser: true,
      isSharePointUserDisabled: false,
      sourceSystemId: DCOP_SOURCE_SYSTEM,
      isOpen: false,
      hseObservationData: null,
      disabledForUser: false
    };
  }

  /**
   * call api when click on edit icon
   */
  componentDidMount() {
    window.scrollTo(0, 0);
    const { incidentId, propertyId } = this.state;
    incidentId &&
      incidentId > 0 &&
      this.getEditIncidentData(incidentId, propertyId);
    uploadFileList = [];
    this.getTooltip();
  }

  getTooltip = () => {
    apiRequest({
      url: API_URL.masterData.GetLabels,
      params: { sectionId: SECTIONS.HSE_INCIDENT_CREATE }
    }).then(({ data: response }) => {
      this.setState({
        getToolTip: response
      });
    });
  };

  /**
   * set the state value after api call is done
   * @param {*} response
   * @returns
   */
  mapIncidentData = response => {
    if (!response.data) return;
    const { loginUserMail } = this.state;
    const createdByUserEmail = response.data?.createdBy;

    const disabledForUser = loginUserMail !== createdByUserEmail;

    const superUser = IsSectionVisible(
      SECTIONS.HSE_INCIDENT_MENU,
      SECTIONS.UPDATE_HSE,
      SECTIONS.ADD_EDIT
    );

    const isSharePointUserDisabled =
      response.data.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
      IsSectionVisible(
        SECTIONS.HSE_INCIDENT_MENU,
        SECTIONS.EVENT_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );

    const {
      projectMasterData,
      categoryMasterData,
      subCategoryMasterData,
      contributingFactorMasterData
    } = this.state;

    const  { dataCenterMasterData } = this.props;

    const propertyId = response.data?.propertyId;

    const disabledProperty = GetPropertyVisibility(SECTIONS.HSE_INCIDENT_CREATE);
    const notSelectedDisabledProperty = disabledProperty.filter(x=> x !== propertyId);
    const dataCenterList = dataCenterMasterData.filter(dc => (notSelectedDisabledProperty || []).find(x=> x === dc.DataCenterId) === undefined);
    

    const contributingFactorId =
      response.data?.contributingFactorId?.split(",") || [];
    const subCategoryMasterDataIds =
      response.data?.subCategoryId?.split(",") || [];
    const categoryType = response.data?.categoryId;
    const projectId = response.data?.projectId;
    // projectName
    const projectName = projectMasterData.find(x => x.ProjectId == projectId)
      ?.Project;
    // datacenter
    const dataCenterName = dataCenterList.find(
      x => x.DataCenterId === propertyId
    )?.DataCenter;
    // category
    const categoryName = categoryMasterData.find(
      x => x.categoryTypeId == categoryType
    )?.categoryType;
    // subcategory
    const subCategoryName = [];
    subCategoryMasterDataIds.forEach(x => {
      subCategoryName.push(
        subCategoryMasterData.find(y => y.SubCategoryId == x)?.SubCategory
      );
    });

    // contributing factor
    const contributingFactorName = [];
    contributingFactorId.forEach(x => {
      contributingFactorName.push(
        contributingFactorMasterData.find(y => y.ContributingFactorId == x)
          ?.ContributingFactor
      );
    });

    this.setState({
      dataCenterMasterData: dataCenterList,
      hasAttachment: response.data.attachment,
      incidentId: response.data.incidentId,
      incidentCode: response.data.incidentCode,
      incidentStatusId: response.data.incidentStatusId,
      incidentStatus: response.data.incidentStatus,
      textDescription: response.data.incidentDescription || "",
      contributingFactorMasterDataIds: contributingFactorName || [],
      subCategoryMasterDataIds: subCategoryName || [],
      project: projectName,
      dataCenter: dataCenterName,
      categoryType: categoryName,
      observationDate: moment(response.data?.observationDate).format(
        "YYYY-MM-DDTHH:mm:ss"
      ),
      incidentNotesHistory:
        response?.data?.incidentNotesHistory?.split("\\n") || [],
      textIncidentNotes: response?.data?.incidentNotes,
      textActionTaken: response?.data?.actionTaken,
      disabledForUser,
      isIncidentAlreadyCreated:
        response.data.incidentStatusId == INCIDENT_STATUS.CREATED,
      createdDate: response.data.createdDate,
      observedBy: response.data.observedBy,
      sourceSystem: response?.data?.sourceSystem,
      isDcopUser: response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM,
      isSharePointUserDisabled,
      superUser,
      sourceSystemId: response?.data?.sourceSystemId,
      hseObservationData: response?.data
    });
  };

  /**
   * get health and safety data from id
   * @param {*} incidentId
   * @param {*} propertyId
   */
  getEditIncidentData = (incidentId, propertyId) => {
    apiBatchRequest([
      {
        url: API_URL.healthSafety.getIncidentById,
        params: {
          incidentId: incidentId,
          DateOffSet: moment().utcOffset(),
          propertyId
        },
        key: "incidentDetails"
      }
    ]).then(({ incidentDetails }) => {
      this.mapIncidentData(incidentDetails);
    });
  };

  /**
   * set state value using key value
   * @param {*} key
   * @param {*} value
   */
  changeState = (key, value) => {
    if (
      key === "contributingFactorMasterDataIds" ||
      key === "subCategoryMasterDataIds"
    ) {
      this.setState({
        [key]: [value]
      });
    } else {
      this.setState({
        [key]: value
      });
    }
  };

  /**
   * call on multiselect method
   * @param {*} ids
   * @param {*} key
   */
  onMultiSelectDD = (ids = [], key = "") => {
    this.setState({
      [key]: ids
    });
  };

  /**
   * check the required and field level validation if everything is ok then prepare the object to pass add or update api
   * @param {*} isRequestSubmitted
   * @returns
   */
  handleSave = isRequestSubmitted => {
    const {
      observedBy,
      textDescription,
      textActionTaken,
      textIncidentNotes,
      dataCenter,
      project,
      categoryType,
      isIncidentAlreadyCreated,
      observationDate,
      contributingFactorMasterDataIds,
      subCategoryMasterDataIds,
      projectMasterData,
      categoryMasterData,
      dataCenterMasterData,
      contributingFactorMasterData,
      subCategoryMasterData,
      loginUserMail,
      incidentId,
      hasAttachment,
      disabledForUser,
      isDcopUser,
      isSharePointUserDisabled,
      sourceSystemId,
      superUser
    } = this.state;
    const currentDate = new Date(moment()).getTime();
    const observedDate = new Date(moment(observationDate)).getTime();

    if (observationDate != undefined && observationDate != null) {
      const result2 = Operators.LessThanEqualsTo(observedDate, currentDate);

      if (!result2.result) {
        ShowToast(
          "Observation Date and Time should not be greater than today's date.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }

    const incidentStatusId = isRequestSubmitted
      ? INCIDENT_STATUS.CREATED
      : INCIDENT_STATUS.DRAFT;
    const selectedDataCenterId = dataCenterMasterData.find(
      x => x.DataCenter === dataCenter
    )?.DataCenterId || 0;
    const selectedProjectId = projectMasterData.find(x => x.Project === project)
      ?.ProjectId || 0;
    const selectedCategoryId = categoryMasterData.find(
      x => x.categoryType === categoryType
    )?.categoryTypeId || 0;
    const selectedContributingFactorId = [];
    contributingFactorMasterDataIds.forEach(x => {
      selectedContributingFactorId.push(
        contributingFactorMasterData.find(y => y.ContributingFactor === x)
          ?.ContributingFactorId
      );
    });
    const selectedSubCategoryMasterDataId = [];
    subCategoryMasterDataIds.forEach(x => {
      selectedSubCategoryMasterDataId.push(
        subCategoryMasterData.find(y => y.SubCategory === x)?.SubCategoryId
      );
    });

    if (
      ((isDcopUser && !disabledForUser) ||
        (!isDcopUser && isSharePointUserDisabled) ||
        superUser) &&
      selectedContributingFactorId.length > 1
    ) {
      ShowToast(
        "Please select only one Contributing Factor.",
        toastType.ERROR,
        5000,
        200
      );
      return;
    } else if (
      ((isDcopUser && !disabledForUser) ||
        (!isDcopUser && isSharePointUserDisabled) ||
        superUser) &&
      selectedSubCategoryMasterDataId.length > 1
    ) {
      ShowToast(
        "Please select only one Sub-Category.",
        toastType.ERROR,
        5000,
        200
      );
      return;
    }

    const requestBody = {
      incidentId: incidentId || 0,
      emailId: loginUserMail,
      categoryId: selectedCategoryId,
      subCategoryId: selectedSubCategoryMasterDataId.join(","),
      observedBy: observedBy,
      contributingFactorId: selectedContributingFactorId.join(","),
      projectId: selectedProjectId,
      propertyId: selectedDataCenterId,
      incidentDescription: textDescription.trim(),
      actionTaken: textActionTaken,
      observationDate: moment(observationDate)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss"),
      incidentNotes: textIncidentNotes,
      incidentStatusId,
      isIncidentAlreadySubmitted: isIncidentAlreadyCreated,
      dateOffset: moment().utcOffset(),
      attachment: uploadFileList.length > 0 ? true : hasAttachment,
      sourceSystemId: sourceSystemId
    };

    const requestValidation = [
      {
        valueKey: "observationDate",
        type: "datetime",
        isRequired: true,
        fieldsName: "Observation Date and Time"
      },
      {
        valueKey: "propertyId",
        type: "text",
        isRequired: true,
        fieldsName: "Data Center"
      },
      {
        valueKey: "categoryId",
        type: "text",
        isRequired: true,
        fieldsName: "Category"
      },
      {
        valueKey: "subCategoryId",
        type: "text",
        isRequired: true,
        fieldsName: "Sub Category"
      },
      {
        valueKey: "contributingFactorId",
        type: "text",
        isRequired: true,
        fieldsName: "Contributing Factor"
      },
      {
        valueKey: "projectId",
        type: "text",
        isRequired: true,
        fieldsName: "Project"
      },
      {
        valueKey: "incidentDescription",
        type: "text",
        isRequired: true,
        fieldsName: "Description"
      }
    ];

    if (validateInput(requestBody, requestValidation)) {
      if (incidentId) {
        this.updateIncidentApi(requestBody);
      } else {
        this.addIncidentApi(requestBody);
      }
    }
  };

  /**
   * add the new hse record and then display successful message and after call the share point method
   * @param {*} params
   */
  addIncidentApi = params => {
    const { hasAttachment } = this.state;
    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      apiPost({
        url: API_URL.healthSafety.CreateIncident,
        postBody: params
      }).then(({ data: response, success: success }) => {
        if (success) {
          ShowToast(
            "Observation added Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
          if (params.attachment)
            this.createSPFolder(response.data.incidentCode);
          else this.props.onSave(true);
        } else {
          this.props.onSave(false);
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      });
    }
  };

  /**
   * update the existing hse record and then display successful message and after call the share point method
   * @param {*} params
   */
  updateIncidentApi = params => {
    const { hasAttachment } = this.state;
    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      apiPut({
        url: API_URL.healthSafety.UpdateIncident,
        postBody: params
      }).then(({ data: response, success: success }) => {
        if (response == null || response?.data.Success == 0) {
          ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
          return false;
        }
        if (success) {
          ShowToast(
            "Observation updated Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
          if (uploadFileList.length > 0)
            this.createSPFolder(response.data.incidentCode);
          else this.props.onSave(true);
        } else {
          this.props.onSave(false);
        }
      });
    }
  };

  /**
   * refresh the hse incident the list
   * @param {*} isRefresh
   */
  refreshIncident = isRefresh => {
    if (isRefresh) {
      this.props.refreshIncident();
    }
  };

  /**
   * create the share point folder if not exist and the upload the file to that folder
   * @param {*} rCode
   * @returns
   */
  createSPFolder = (rCode = "") => {
    if (!rCode) return;
    if (getSPSTokenData()) {
      getSpsAPiRequest(getSharepointUrl("getInnerFolder", rCode)).then(() => {
        this.setState({ openDialog: true });
        this.onFileUpload(rCode);
      });
    } else {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
        }
      });
    }
  };

  /**
   * validate the file if uploaded file is not correct format
   * @returns
   */
  validateFile = () => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      errorMessage;
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    }
    return isFileValid;
  };

  /**
   * upload the file on onchange event
   * @param {*} rCode
   */
  onFileUpload = rCode => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    const filesToUpload = uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    } else if (filesToUpload.length > 0) {
      this.setState({  hasAttachment: true });
      for (let index = 0; index < filesToUpload.length; index++) {
        spsApiPost({
          url: getSharepointUrl(
            "uploadFileSession",
            rCode,
            `${rCode}_${filesToUpload[index].fileData.name}`
          ),
          postBody: {
            fileSize: filesToUpload[index].fileData.size,
            item: {
              "@microsoft.graph.conflictBehavior": "replace"
            }
          }
        }).then(data => {
          if (data) {
            uploadSpsAPiRequest(
              data.data.uploadUrl,
              filesToUpload[index].fileData,
              true
            ).then(data => {
              if (data) {
                ShowToast("File uploaded successfully.", toastType.SUCCESS);
                this.props.onSave(true);
              } else {
                ShowToast("File not uploaded successfully.", toastType.ERROR);
                this.props.onSave(true);
              }
              this.setState({ openDialog: false });
            });
          }
        });
      }
    }
  };

  /**
   * set uploaded file list
   * @param {*} list
   */
  setUploadFilesList = list => {
    uploadFileList = list;
  };

  /**
   * call on change switch button request
   * @param {*} value
   * @param {*} key
   */
  onChangeSwitchBtn = (value, key) => {
    this.setState({ [key]: value });
  };

  /**
   * call when click on close popup icon
   */
  closePopup = () => {
    this.setState({
      isOpen: false
    });
  };

  /**
   * call on print the HSE record
   */
  handlePrint = () => {
    const { incidentId, propertyId } = this.state;
    const param =
      "IncidentId=" +
      incidentId +
      "&DateOffset=" +
      moment().utcOffset() +
      "&PropertyId=" +
      propertyId;
    printForm(
      `${PRINT_HSE_FORM}${param}`,
      "Blank form",
      "application/pdf",
      "HSE"
    );
  };

  render() {
    const {
      incidentId,
      incidentCode,
      incidentStatusId,
      incidentStatus,
      observedBy,
      categoryType,
      project,
      dataCenter,
      observationDate,
      createdDate,
      contributingFactorMasterDataIds,
      subCategoryMasterDataIds,
      projectMasterData,
      categoryMasterData,
      contributingFactorMasterData,
      subCategoryMasterData,
      dataCenterMasterData,
      disabledForUser,
      textIncidentNotes,
      textDescription,
      hasAttachment,
      sourceSystem,
      isDcopUser,
      isSharePointUserDisabled,
      superUser,
      isOpen,
      hseObservationData,
      getToolTip,
      incidentNotesHistory,
      openDialog
    } = this.state;

    const isFieldsEnabled = IsSectionVisible(
      SECTIONS.HSE_INCIDENT_MENU,
      SECTIONS.HSE_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );
    const createdDateTime = createdDate
      ? moment(createdDate).format("MM/DD/YYYY hh:mm A")
      : moment(new Date()).format("MM/DD/YYYY hh:mm A");

    return (
      <div className={"row addUpdateReqPage"}>
        <div className={"row col-xs-12 mb-3 incident-label"}>
          {incidentId > 0 && (
            <div className={"col-xs-2"}>
              <InputLabel
                disabled={!isFieldsEnabled}
                className={"small-label"}
                size={"small"}
                id={"incidentCode"}
              >
                {"Observation # : "}
                {incidentCode}
              </InputLabel>
            </div>
          )}
          {incidentId > 0 && (
            <div className={"col-xs-2"}>
              <InputLabel
                disabled={!isFieldsEnabled}
                className={"small-label"}
                size={"small"}
                id={"incidentStatus"}
              >
                {"Observation Status : "}
                {incidentStatus}
              </InputLabel>
            </div>
          )}
          <div className={"col-xs-2"}>
            <InputLabel
              disabled={!isFieldsEnabled}
              className={"small-label"}
              size={"small"}
              id={"createdOn"}
            >
              {"Created On : "}
              {createdDateTime ? createdDateTime : null}
            </InputLabel>
          </div>
          <div className={"col-xs-3"}>
            <InputLabel
              disabled={!isFieldsEnabled}
              className={"small-label"}
              size={"small"}
              id={"sourceSystem"}
            >
              {"Source System : "}
              {sourceSystem ? sourceSystem : null}
            </InputLabel>
          </div>
          {incidentId > 0 && (
            <div className={"col-xs-12 col-md-12 col-lg-12 end-xs"}>
              <Tooltip title={getToolTipText(getToolTip, TOOLTIP_LABEL.PRINT)}>
                <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                  <PrintIcon
                    onClick={() => {
                      this.handlePrint();
                    }}
                    style={{ fontSize: "2rem" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </div>
        <div className={"row col-xs-12 rowList step1-parent"}>
          <div className={"col-xs-12"} style={{ paddingRight: "1.5rem" }}>
            <div className={"row content"}>
              <div className={"col-xs-3"}>
                <TextFieldWithToolTip
                  isRequired={false}
                  labelHeading={"Observed By"}
                  value={observedBy}
                  disabled
                  className={"box-style"}
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.OBSERVED_BY
                  )}
                />
              </div>
              <div className={"col-xs-3 content"}>
                <KeyBoardDateTimePickers
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.OBSERVATION_DATE_AND_TIME
                  )}
                  valueDate={observationDate}
                  disabled={
                    superUser
                      ? false
                      : (isDcopUser && !isFieldsEnabled) ||
                        (isDcopUser && !IsAdmin() && disabledForUser) ||
                        (!isDcopUser && !isSharePointUserDisabled)
                  }
                  label={"Observation Date and Time"}
                  format={"MM/DD/YYYY hh:mm A"}
                  required
                  maxDate={moment().format("MM/DD/YYYY")}
                  handleChange={date =>
                    this.setState({ observationDate: date })}
                />
              </div>

              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Data Center"}
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.DATA_CENTER
                  )}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      dataCenterMasterData || [],
                      "DataCenter",
                      "DataCenter"
                    ),
                    x => x.id
                  )}
                  isRequired
                  selectedId={dataCenter}
                  keyValue={"dataCenter"}
                  onChange={this.changeState}
                  disabled={
                    (isDcopUser &&
                      (incidentStatusId > 1 || !isFieldsEnabled)) ||
                    (!isDcopUser && true)
                  }
                />
              </div>
              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Category"}
                  id={"Category"}
                  toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.CATEGORY)}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      categoryMasterData || [],
                      "categoryType",
                      "categoryType"
                    ),
                    x => x.id
                  )}
                  isRequired
                  selectedId={categoryType}
                  keyValue={"categoryType"}
                  onChange={this.changeState}
                  disabled={
                    superUser
                      ? false
                      : (isDcopUser &&
                          incidentStatusId > 1 &&
                          disabledForUser) ||
                        (isDcopUser && !isFieldsEnabled) ||
                        (!isDcopUser && !isSharePointUserDisabled)
                  }
                />
              </div>
              <div className={"col-xs-3"}>
                {incidentId && incidentId > 0 ? (
                  <MultiSelectDD
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.SUB_CATEGORY
                    )}
                    className={"box-style"}
                    header={"Sub Category"}
                    minWidth={"120px"}
                    optionsList={uniqBy(
                      convertIntoDDFormat(
                        subCategoryMasterData || [],
                        "SubCategory",
                        "SubCategory"
                      ),
                      x => x.id
                    )}
                    isRequired
                    selectedIds={subCategoryMasterDataIds || []}
                    onChange={ids =>
                      this.onMultiSelectDD(ids, "subCategoryMasterDataIds")}
                    showToolTip
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser &&
                            incidentStatusId > 1 &&
                            disabledForUser) ||
                          (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                    showSelectAll={false}
                  />
                ) : (
                  <LabelWithSelect
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.SUB_CATEGORY
                    )}
                    className={"box-style"}
                    labelHeading={"Sub Category"}
                    minWidth={"120px"}
                    optionsList={uniqBy(
                      convertIntoDDFormat(
                        subCategoryMasterData || [],
                        "SubCategory",
                        "SubCategory"
                      ),
                      x => x.id
                    )}
                    isRequired
                    selectedId={subCategoryMasterDataIds[0]}
                    onChange={this.changeState}
                    keyValue={"subCategoryMasterDataIds"}
                    showToolTip
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser &&
                            incidentStatusId > 1 &&
                            disabledForUser) ||
                          (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                  />
                )}
              </div>
              <div className={"col-xs-3"}>
                {incidentId && incidentId > 0 ? (
                  <MultiSelectDD
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.CONTRIBUTING_FACTOR
                    )}
                    className={"box-style"}
                    header={"Contributing Factor"}
                    minWidth={"120px"}
                    required
                    optionsList={uniqBy(
                      convertIntoDDFormat(
                        contributingFactorMasterData || [],
                        "ContributingFactor",
                        "ContributingFactor"
                      ),
                      x => x.id
                    )}
                    isRequired
                    selectedIds={contributingFactorMasterDataIds || []}
                    onChange={ids =>
                      this.onMultiSelectDD(
                        ids,
                        "contributingFactorMasterDataIds"
                      )}
                    showToolTip
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser &&
                            incidentStatusId > 1 &&
                            disabledForUser) ||
                          (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                    showSelectAll={false}
                  />
                ) : (
                  <LabelWithSelect
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.CONTRIBUTING_FACTOR
                    )}
                    className={"box-style"}
                    labelHeading={"Contributing Factor"}
                    minWidth={"120px"}
                    required
                    optionsList={uniqBy(
                      convertIntoDDFormat(
                        contributingFactorMasterData || [],
                        "ContributingFactor",
                        "ContributingFactor"
                      ),
                      x => x.id
                    )}
                    isRequired
                    selectedId={contributingFactorMasterDataIds[0]}
                    onChange={this.changeState}
                    keyValue={"contributingFactorMasterDataIds"}
                    showToolTip
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser &&
                            incidentStatusId > 1 &&
                            disabledForUser) ||
                          (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                  />
                )}
              </div>
              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  id={"selectProject"}
                  labelHeading={"Project"}
                  toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.PROJECTS)}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      projectMasterData || [],
                      "Project",
                      "Project"
                    ),
                    x => x.id
                  )}
                  isRequired
                  selectedId={project}
                  keyValue={"project"}
                  onChange={this.changeState}
                  disabled={
                    superUser
                      ? false
                      : (isDcopUser &&
                          incidentStatusId > 1 &&
                          disabledForUser) ||
                        (isDcopUser && !isFieldsEnabled) ||
                        (!isDcopUser && !isSharePointUserDisabled)
                  }
                />
              </div>
              {!isDcopUser && (
                <div className={"col-xs-3 content"}>
                  <div
                    className={"compContainer"}
                    style={{ marginTop: "43px" }}
                  >
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          isOpen: true
                        });
                      }}
                    >
                      {"Show More...\r"}
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding content"}>
                <div className={"compContainer"}>
                  <InputLabelWithToolTip
                    className={"compLabel"}
                    id={"requestDescriptionLabel"}
                    disabled={
                      (isDcopUser &&
                        (incidentStatusId > 1 || !isFieldsEnabled)) ||
                      (!isDcopUser && true)
                    }
                    isRequired
                    labelHeading={"Description"}
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.DESCRIPTION
                    )}
                  />

                  <TextareaAutosize
                    rowsMin={4}
                    rowsMax={4}
                    aria-label={"Description"}
                    placeholder={"Description"}
                    value={textDescription}
                    onChange={e =>
                      this.changeState("textDescription", e.target.value)}
                    disabled={
                      (isDcopUser &&
                        (incidentStatusId > 1 || !isFieldsEnabled)) ||
                      (!isDcopUser && true)
                    }
                  />
                </div>
              </div>
            </div>
            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding content"}>
                <div className={"compContainer"}>
                  <InputLabelWithToolTip
                    className={"compLabel"}
                    id={"notesLabel"}
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                    isRequired={false}
                    labelHeading={"Notes"}
                    toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.NOTES)}
                  />
                  <TextareaAutosize
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                    rowsMin={4}
                    rowsMax={4}
                    className={"borderSize"}
                    aria-label={"IncidentNotes"}
                    placeholder={"Notes"}
                    value={textIncidentNotes}
                    onChange={e =>
                      this.changeState("textIncidentNotes", e.target.value)}
                  />
                  <div
                    className={
                      (superUser
                      ? true
                      : (isDcopUser && isFieldsEnabled == false) ||
                        (!isDcopUser && !isSharePointUserDisabled))
                        ? "response-disabled response-box-top-border"
                        : "response-box response-box-top-border"
                    }
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                  >
                    {incidentNotesHistory ? (
                      incidentNotesHistory.map(res => (
                        <>
                          <div
                            className={"response"}
                            disabled={
                              superUser
                                ? false
                                : (isDcopUser && !isFieldsEnabled) ||
                                  (!isDcopUser && !isSharePointUserDisabled)
                            }
                          >
                            {res.split("\\s")[0]}
                          </div>
                          <div
                            className={"response-small"}
                            disabled={
                              superUser
                                ? false
                                : (isDcopUser && !isFieldsEnabled) ||
                                  (!isDcopUser && !isSharePointUserDisabled)
                            }
                          >
                            {res.split("\\s")[1]}
                          </div>
                          <div>
                            {" "}
                            <br />{" "}
                          </div>
                        </>
                      ))
                    ) : (
                      <div className={"response"} />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding"}>
                <div style={{ marginLeft: "12px" }}>
                  <FileAttachments
                    hasAttachment={hasAttachment}
                    requestCode={incidentCode}
                    setUploadFilesList={this.setUploadFilesList}
                    downloadPermission={
                      superUser
                        ? true
                        : (isDcopUser &&
                            IsSectionVisible(
                              SECTIONS.HSE_INCIDENT_MENU,
                              SECTIONS.HSE_INCIDENT_CREATE,
                              SECTIONS.ADD_EDIT
                            )) ||
                          (!isDcopUser && isSharePointUserDisabled)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={"col-xs-12 end-xs req_actions"}>
          <Button
            autoFocus
            onClick={() => this.props.refreshIncident(false)}
            variant={"contained"}
          >
            {"Cancel\r"}
          </Button>
          {
            <>
              {incidentStatusId <= 1 &&
                ((isDcopUser &&
                  IsSectionVisible(
                    SECTIONS.HSE_INCIDENT_MENU,
                    SECTIONS.HSE_INCIDENT_CREATE,
                    SECTIONS.ADD_EDIT
                  )) ||
                  (!isDcopUser && isSharePointUserDisabled)) && (
                  <>
                    <Button
                      autoFocus
                      onClick={() => this.handleSave(false)}
                      variant={"contained"}
                    >
                      {"Save As Draft\r"}
                    </Button>
                  </>
                )}
              {(superUser
                ? true
                : (isDcopUser &&
                    IsSectionVisible(
                      SECTIONS.HSE_INCIDENT_MENU,
                      SECTIONS.HSE_INCIDENT_CREATE,
                      SECTIONS.ADD_EDIT
                    )) ||
                  (!isDcopUser && isSharePointUserDisabled)) && (
                <Button
                  autoFocus
                  onClick={() => this.handleSave(true)}
                  variant={"contained"}
                >
                  {"Submit\r"}
                </Button>
              )}
            </>
          }
        </div>
        {openDialog && (
          <Dialog
            style={{ marginTop: "60px" }}
            open={openDialog}
            aria-labelledby={"responsive-dialog-title"}
            maxWidth={"lg"}
          >
            <div style={{ padding: "4px 13px", fontSize: "larger" }}>
              {"Uploading file...\r"}
            </div>
          </Dialog>
        )}

        {isOpen && (
          <Dialog
            id={"event-notification-details"}
            maxWidth={"lg"}
            open={isOpen}
            onClose={() => this.closePopup()}
            PaperComponent={PaperComponent}
            aria-labelledby={"responsive-dialog-title"}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  <DialogTitle
                    style={{ cursor: "move" }}
                    id={"responsive-dialog-title"}
                    className={"common-color white-label"}
                  >
                    {"Event Notification Details\r"}
                  </DialogTitle>
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => this.closePopup()}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>
            <DialogContent>
              <DialogContentText>
                <Table>
                  <TableBody>
                    {hseEventNotification.map((col, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell key={index + col.name}>
                            <b>{col.name}</b>
                          </TableCell>
                          <TableCell key={index + col.key}>
                            {hseObservationData[col.key] !== undefined &&
                            hseObservationData[col.key] !== null &&
                            hseObservationData[col.key] !== "" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: hseObservationData[col.key]
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
      </div>
    );
  }
}
export default AddUpdateIncident;
